module.exports = __webpack_public_path__ + "img/running-module.10d0e834.svg";